import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import DeprecatedSelect from "../../../src/View/UI/DeprecatedSelect/DeprecatedSelect";
const createLabelValueObject = (person) => ({
    value: person,
    label: `${person.fullName} (${person.studentId})`,
});
/**
 * Maps the loader's response to a label value object for selectAsync.
 *
 * @param {*} loader - a function which returns a promise of an array of people
 * @param {string} query - The query to filter results by
 */
const mapLoader = (loader, query) => loader(query).then((data) => ({ options: data.map(createLabelValueObject) }));
export default class FromTo extends Component {
    constructor(props) {
        super(props);
        this.loadFromOptions = (query) => {
            this.setState({ fromError: null });
            return mapLoader(this.props.loadFromOptions, query).catch(() => this.setState({ fromError: this.errorMessage }));
        };
        this.loadToOptions = (query) => {
            this.setState({ toError: null });
            return mapLoader(this.props.loadToOptions, query).catch(() => this.setState({ toError: this.errorMessage }));
        };
        this.state = {
            fromError: null,
            toError: null,
        };
        this.errorMessage = "There was a problem loading people";
    }
    render() {
        return (_jsxs("div", { children: [_jsxs("div", { className: "row", children: [_jsx("div", { className: "col", children: _jsx("label", { htmlFor: "fromPerson", children: "From" }) }), _jsx("div", { className: "col-auto", children: _jsx("span", { className: "fa fa-fw fa-2x", "aria-hidden": true }) }), _jsx("div", { className: "col", children: _jsx("label", { htmlFor: "toPerson", children: "To" }) })] }), _jsxs("div", { className: "row align-items-center", children: [_jsx("div", { className: "col", children: _jsx(DeprecatedSelect.Async, { "aria-label": "From Person", id: "fromPerson", loadOptions: this.loadFromOptions, onChange: (val) => this.props.onFromChange(val ? val.value : null), value: this.props.fromPerson
                                    ? createLabelValueObject(this.props.fromPerson)
                                    : "" }) }), _jsx("div", { className: "col-auto", children: _jsx("span", { className: "fa fa-long-arrow-alt-right fa-fw", "aria-hidden": true }) }), _jsx("div", { className: "col", children: _jsx(DeprecatedSelect.Async, { "aria-label": "To Person", id: "toPerson", loadOptions: this.loadToOptions, onChange: (val) => this.props.onToChange(val ? val.value : null), value: this.props.toPerson
                                    ? createLabelValueObject(this.props.toPerson)
                                    : "" }) })] }), (this.state.fromError || this.state.toError) && (_jsxs("div", { className: "row", children: [_jsx("div", { className: "col", children: this.state.fromError && (_jsx("small", { className: "text-danger", children: this.state.fromError })) }), _jsx("div", { className: "col-auto", children: _jsx("span", { className: "fa fa-fw fa-2x", "aria-hidden": true }) }), _jsx("div", { className: "col", children: this.state.toError && (_jsx("small", { className: "text-danger", children: this.state.toError })) })] }))] }));
    }
}
